import genererGuid from '@/services/general/genererGuid';
import adresseGenerer from '@/services/general/adresseManager';
import { MODE_CALCUL_MANUEL, POURCENTAGE, TYPE_REMISE_CASCADE, ANNEE } from '@/configurations/recomConfig';

function genererModeCalculHonoraire() {
  return {
    modeCalcul: MODE_CALCUL_MANUEL,
    applicableSurLocation: false,
    applicableSurTlpe: false,
    applicableSurDivers: false,
    commentaire: null,
    montantForfaitHt: null,
    pourcentage: null,
    montantHonoraireForfaitaire: null,
    montantHonoraireFraisTraitement: null,
    creation: true,
  };
}

function genererRemise() {
  return {
    typeRemise: POURCENTAGE,
    selected: false,
    type: TYPE_REMISE_CASCADE,
    ordre: 0,
    libelle: '',
    montant: 0,
    remise: 0,
    isRemiseRegie: false,
  };
}

export function genererBudget() {
  return {
    dateDebut: null,
    dateFin: null,
    dateFinPremiereEcheance: null,
    prixBrutNegocie: null,
    prixNet: null,
    tlpe: null,
    fraisTechnique: null,
    honoraires: null,
    honoraireFraisTraitement: null,
    afficherSurEdition: true,
    prixTotal: 0,
    modeCalculHonoraire: genererModeCalculHonoraire(),
    remise: genererRemise(),
    guid: genererGuid(),
    ligneCommandeId: null,
    ligneCommandeIds: {
      location: null,
      tlpe: null,
      honoraires: null,
      fraisTechnique: null,
      honoraireFraisTraitement: null,
    },
    prixUnitaireBrut: null,
    quantiteBrut: 1,
    uniteQteBrut: ANNEE,
    prixUnitaireTlpe: null,
    quantiteTlpe: 1,
    uniteQteTlpe: ANNEE,
  };
}

export default function genererPanneau() {
  return {
    guid: genererGuid(),
    icon: '',
    urlLogo: '',
    srcImg: '',
    heightImg: 0,
    adresse: adresseGenerer(),
    regie: '',
    regieId: null,
    referenceConfrere: '',
    categorie: {},
    format: '',
    formatId: null,
    materiel: '',
    support: '',
    azimut: 0,
    commentaire: '',
    budgetGeneration: genererBudget(),
    budgets: [],
    streetView: false,
    ancienPanneau: 'NON',
    ligneCommandeId: null,
    estPanneauSousContrat: false,
    actif: true,
    produitId: null,
    referencePanneau: '',
  };
}
